import { ViteReactSSG } from "vite-react-ssg";
import { routes } from "./App";
import { initPostHog } from "./lib/analytics";
import "./index.css";

export const createRoot = ViteReactSSG({ routes }, ({ isClient }) => {
  // Init navigateur uniquement (Sentry + PostHog) — jamais pendant le pré-rendu Node
  if (!isClient) return;

  // Sentry (replay inclus) + PostHog pèsent lourd : on les charge à l'idle,
  // après le premier rendu — pas sur le chemin critique du LCP.
  const boot = () => {
  void (async () => {
    const Sentry = await import("@sentry/react");
    Sentry.init({
      dsn: import.meta.env.VITE_SENTRY_DSN,
      environment: import.meta.env.MODE,
      tracesSampleRate: import.meta.env.PROD ? 0.1 : 1.0,
      replaysOnErrorSampleRate: 1.0,
      replaysSessionSampleRate: 0.05,
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration({ maskAllText: true }),
      ],
      ignoreErrors: [
        "ResizeObserver loop limit exceeded",
        /^Network Error$/,
        /^Failed to fetch$/,
      ],
    });
  })();

    initPostHog();
  };
  if (typeof window.requestIdleCallback === "function") window.requestIdleCallback(boot, { timeout: 5000 });
  else setTimeout(boot, 3000);
});
